import * as R from 'rambdax'
import {logger} from 'tizra'

const log = logger('quickstart/theme/base/utils')

export const makeTypographyTable = (s: string) => {
  let table = {} as any
  const current = {} as any
  for (let line of s.split('\n')) {
    line = line.replace(/\/\/.*/, '').trimEnd()
    if (!line) {
      continue
    }
    let [bp, v, ...rest] = line.split(/\s+/)
    if (!bp && !v) {
      log.error('asoiefjaoseifj')
      continue
    }
    bp = current.bp = bp || current.bp
    if (v) {
      const spec = {} as any
      const fs = rest.find(s => s.includes('/'))
      if (fs) {
        const [size, height] = fs.split('/').map(s => parseFloat(s))
        if (size) {
          spec.size = {[bp]: size}
        }
        if (height) {
          spec.height = {[bp]: height}
        }
      }
      const m = rest.find(s => /^(?:\d*[.]\d+|\d+)$/.test(s))
      if (m) {
        spec.margin = {[bp]: parseFloat(m)}
      }
      const w = rest.find(s => ['light', 'regular', 'bold'].includes(s))
      if (w) {
        spec.weight = {[bp]: w}
      }
      table = R.mergeDeepRight(table, {[v]: spec})
    }
  }
  return table
}
